import 'css-chunksrc/client/pages/projectPage/kanbanPage/column/task/styles.scss';export default {
  "task": "_task_fbtcj_1",
  "header": "_header_fbtcj_12",
  "name": "_name_fbtcj_18",
  "description": "_description_fbtcj_24",
  "dates": "_dates_fbtcj_31",
  "late": "_late_fbtcj_38",
  "dateLabel": "_dateLabel_fbtcj_42",
  "hierarchy": "_hierarchy_fbtcj_47",
  "constraintsPopup": "_constraintsPopup_fbtcj_52",
  "tagList": "_tagList_fbtcj_57",
  "taskSpace": "_taskSpace_fbtcj_62",
  "constrained": "_constrained_fbtcj_66",
  "done": "_done_fbtcj_70"
};